var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"La1",style:({
  gridTemplateColumns: _vm.ratio
})},[_c('div',{staticClass:"La1_left"},[_vm._t("left"),(_vm.popupL)?_c('div',{staticClass:"popup"},[_vm._t("popupL")],2):_vm._e()],2),_c('div',{staticClass:"La1_right"},[_vm._t("default"),(_vm.popupR)?_c('div',{staticClass:"popup"},[_vm._t("popupR")],2):_vm._e()],2),(_vm.popup)?_c('div',{staticClass:"popup"},[_vm._t("popup")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }